import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {ExFormDto, ExFormFieldDto, FieldAccessEnum} from "../../interfaces/core.types";
import {FormBuilder, FormControlStatus, FormGroup, Validators} from "@angular/forms";

type DynamicStringObject = {
  [key: string]: string;
};

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls:['form.component.scss']
})
export class FormComponent extends CoreComponent implements OnInit, OnChanges {

  @Input() form?: ExFormDto;

  @Output() onFormGroupValueChange = new EventEmitter<any>();
  @Output() onFormGroupStatusChange = new EventEmitter<FormControlStatus>();

  @Output() onSubmit = new EventEmitter<{value: any, status: FormControlStatus}>();

  formGroup?: FormGroup;

  private previousValues: DynamicStringObject = {};

  formFields?: ExFormFieldDto[];

  constructor(private fb: FormBuilder) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();

    //this.refreshComponent();
  }

  refreshComponent() {

    if (this.formGroup) {
      this.previousValues = this.formGroup.value;
    }

    this.formGroup = this.createFormGroup();

    this.formGroup.statusChanges.subscribe(value => {
      this.onFormGroupStatusChange.emit(value);
    });

    this.formGroup.valueChanges.subscribe(value => {
      this.onFormGroupValueChange.emit(value);
    });

    this.initialized = true;

  }

  createFormGroup(): FormGroup {

    this.formFields = [];

    const group: FormGroup = this.fb.group({});

    this.form?.formFields.forEach(field => {

      // remove hidden fields
      if (field.access == "hidden") {
        return;
      }

      // if (field.id != "id") {
      //   const control = this.fb.control(
      //     field.value,
      //     field.uiMandatory ? Validators.required : []
      //   );
      //   group.addControl(field.id, control);
      //
      //   this.formFields?.push(field);
      // }

      if (field.id != "id") {
        const controlValue = this.previousValues[field.id] !== undefined ? this.previousValues[field.id] : field.value;
        const control = this.fb.control(
          controlValue,
          field.uiMandatory ? Validators.required : []
        );
        group.addControl(field.id, control);

        this.formFields?.push(field);
      }

    });

    // return current status
    this.onFormGroupStatusChange.emit(group.status);

    // return current values
    this.onFormGroupValueChange.emit(group.value);

    return group;
  }

  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);

    if (changes["form"]) {
      this.refreshComponent();
    }

  }


  handleSubmit() {
    if (this.formGroup) {
      this.onSubmit.emit({
        value: this.formGroup.value,
        status: this.formGroup.status
      });
    }
  }

}
